module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/cn/carro_45t_small.7f292e95.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/cn/carro_45t_small.png
// module id = 1024
// module chunks = 16